import React, { Suspense, useEffect } from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import { useColorModes } from "@coreui/react";
import "./scss/style.scss";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { setupSyncfusionLocalisation } from "./utils/syncfusionLocalization";

setupSyncfusionLocalisation();
// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const GetStarted = React.lazy(() => import("./views/getstarted/GetStarted"));
const Companies = React.lazy(() => import("./views/company/Companies"));
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes(
    "coreui-free-react-admin-template-theme"
  );
  const storedTheme = useSelector((state) => state.sidebar.theme);
  const currentTheme = useSelector((state) => state.theme?.theme);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split("?")[1]);
    const theme =
      urlParams.get("theme") &&
      urlParams.get("theme").match(/^[A-Za-z0-9\s]+/)[0];
    if (theme) {
      setColorMode(theme);
    }

    if (isColorModeSet()) {
      return;
    }

    setColorMode(storedTheme);
  }, [isColorModeSet, setColorMode, storedTheme]);

  // Global Syncfusion theme management
  useEffect(() => {
    const loadSyncfusionTheme = () => {
      // Remove existing theme link if it exists
      const existingThemeLink = document.getElementById('syncfusion-theme');
      if (existingThemeLink) {
        existingThemeLink.remove();
      }

      // Create new theme link
      const themeLink = document.createElement('link');
      themeLink.id = 'syncfusion-theme';
      themeLink.rel = 'stylesheet';

      if (currentTheme === 'dark') {
        themeLink.href = 'https://cdn.syncfusion.com/ej2/27.2.2/bootstrap5-dark.css';
      } else {
        themeLink.href = 'https://cdn.syncfusion.com/ej2/27.2.2/bootstrap5.css';
      }

      document.head.appendChild(themeLink);
    };

    // Only load theme if currentTheme is available
    if (currentTheme) {
      loadSyncfusionTheme();
    }
  }, [currentTheme]);

  return (
    <HashRouter>
      <Suspense
        fallback={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "70vh" }}
          >
            <div
              className="spinner-border"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      >
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route
            exact
            path="/signup"
            name="Register Page"
            element={<Register />}
          />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          {/* <Route path="/app/*" name="Home" element={<DefaultLayout />} /> */}
          <Route
            exact
            path="/companies"
            element={
              <ProtectedRoute>
                <Companies />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/getstarted"
            name="Get Started"
            element={
              <ProtectedRoute>
                <GetStarted />
              </ProtectedRoute>
            } />
          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <DefaultLayout />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/companies" />} />
          {/* <ProtectedRoute path="/app/*" name="Home" element={<DefaultLayout />} /> */}
        </Routes>
      </Suspense>
    </HashRouter>
  );
};

export default App;
